module.exports = __webpack_public_path__ + "static/media/documents.3a8e43f7.png";